export const writeUs = [
    {
      label: 'Start here',
      href: '/persons-contact',
      backgroundColor: 'white',
      color: '#00A1FD',
      size:'lg' as 'lg',
      textSize:'lg' as 'lg',
      mobileTabletSize:'md' as 'md',
      mobileTextSize:'md' as 'md',
      borderRadius:'40px',
    },
  ];

export const githubLink = [
{
    label: 'GitHub',
    href: 'https://github.com/sitemule',
    backgroundColor: 'rgba(255, 255, 255, .85',
    color: '#2C8E27',
    size:'lg' as 'lg',
    textSize:'lg' as 'lg',
    mobileTabletSize:'md' as 'md',
    mobileTextSize:'md' as 'md',
    borderRadius:'40px',
    icon:'github-icon',
},
];

export const images = [
{
    selector: '.app-customer-demand',
    backgroundColor: ' rgb(23, 122, 244, .89)',
    backgroundImage: 'assets/images/integration-transformation-inovation.jpg',
},
{
    selector: '.app-web-based-service-integration',
    backgroundColor: ' rgb(23, 122, 244, .89)',
    backgroundImage: '/assets/images/integration-1.jpg',
},
{
    selector: '.app-web-based-service-transformation',
    backgroundColor: ' rgb(23, 122, 244, .89)',
    backgroundImage: '/assets/images/transformation.jpg',
},
{
    selector: '.app-web-based-service-innovation',
    backgroundColor: ' rgb(23, 122, 244, .89)',
    backgroundImage: '/assets/images/innovation.jpg',
},
{
    selector: '.app-customers',
},
{
    selector: '.app-technical',
},
{
    selector: '.app-persons',
},
{
  selector: 'app-contact-form',
},
{
    selector: '.app-new-footer',
},
];

export const content = [
{
    text: 'Hero header',
    link: '/#hero',
},
{
    text: 'Integration',
    link: '/#integration',
},
{
    text: 'Transformation',
    link: '/#transformation',
},
{
    text: 'Innovation',
    link: '/#innovation',
},
{
    text: 'Our Relationships',
    link: '/#relations',
},
{
    text: 'Get Technical',
    link: '/#technical',
},
{
    text: 'Sitemule - team',
    link: '/#team',
},
{
    text: 'Lets talk',
    link: '/#lets-have-a-talk',
},
];

export const bannerLink = [
    {
        label: 'Kom igang',
        href: '/contact',
        backgroundColor: '#00A1FD',
        color: 'white',
        size: 'lg' as 'lg',
        textSize: 'lg' as 'lg',
        mobileTabletSize: 'md' as 'md',
        mobileTextSize: 'md' as 'md',
        borderRadius: '36px',
    },
    ];

export const links = [
{
    label: 'Start here ',
    href: '/persons-contact',
    backgroundColor: 'rgba(255, 255, 255, .85)',
    color: '#00A1FD',
    size: 'lg' as 'lg',
    textSize: 'lg' as 'lg',
    mobileTabletSize: 'md' as 'md',
    mobileTextSize: 'md' as 'md',
    borderRadius: '36px',
},
];
